// import ReactDOM from "react-dom";
// import "./index.css";
// import { QueryClientProvider, QueryClient } from "react-query";
// import { ReactQueryDevtools } from 'react-query/devtools'
// import App from "./App";
// const queryClient = new QueryClient();

// ReactDOM.render(<QueryClientProvider client={queryClient}>
//     <App />
//     <ReactQueryDevtools initialIsOpen />
// </QueryClientProvider>, document.getElementById("root"));
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import * as Ably from "ably";
import { AblyProvider } from "ably/react";
import { ReactQueryDevtools } from "react-query/devtools";
import App from "./App";
import { CONFIGS } from "Components/Constants/Configs";

const queryClient = new QueryClient();
const realtimeClient = new Ably.Realtime({
  key: process.env.REACT_APP_ABLY_KEY,
  clientId: "big-chef",
});

export const realtime = new Ably.Realtime(CONFIGS.ABLEY_API_KEY)

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AblyProvider client={realtimeClient}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AblyProvider>
  </React.StrictMode>,
);
